import { CONTENT_TYPE_FIELD, CpsDocumentMetadataValue } from '@cs-cms/types';
import { CpsGridDocument } from '../../cpsGridTypes';
import { ClickedCellMetadata } from './FilterActions.types';

const CELL_FIELD_ATTRIBUTE = 'data-field';

function isStringArray(value: unknown[]): value is string[] {
  return value.every(item => typeof item === 'string');
}

export function toCellPrefillValue(value: unknown): Exclude<CpsDocumentMetadataValue, undefined> | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value instanceof Date) {
    return value;
  }

  if (Array.isArray(value) && value.length > 0 && isStringArray(value)) {
    return value;
  }

  return undefined;
}

export function resolveClickedCellMetadata(
  target: HTMLElement,
  document: CpsGridDocument
): ClickedCellMetadata | undefined {
  const cell = target.closest(`td[${CELL_FIELD_ATTRIBUTE}]`);
  if (!(cell instanceof HTMLElement)) {
    return undefined;
  }

  const fieldName = cell.getAttribute(CELL_FIELD_ATTRIBUTE);
  if (!fieldName) {
    return undefined;
  }

  const value = toCellPrefillValue(document[fieldName]);
  if (value === undefined) {
    return undefined;
  }

  const contentType = document[CONTENT_TYPE_FIELD];
  if (!contentType) {
    return undefined;
  }

  return {
    fieldName,
    value,
    contentType
  };
}
